<template>
  <nav
    v-if="breadcrumbs.length"
    class="admin-breadcrumbs"
    aria-label="Хлебные крошки"
  >
    <ol class="admin-breadcrumbs__list">
      <li
        v-for="(item, index) in breadcrumbs"
        :key="`${item.label}-${index}`"
        class="admin-breadcrumbs__item"
      >
        <router-link
          v-if="item.to && index !== breadcrumbs.length - 1"
          :to="item.to"
          class="admin-breadcrumbs__link"
        >
          {{ item.label }}
        </router-link>
        <span v-else class="admin-breadcrumbs__current">
          {{ item.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script>
import { navigationRoutes } from "./app-sidebar/NavigationRoutes";

const extraBreadcrumbsByRouteName = {
  "product-create": { label: "Создание товара", parentName: "products" },
  "product-edit": { label: "Редактирование товара", parentName: "products" },
  "order-create": { label: "Создание заказа", parentName: "orders" },
  "order-edit": { label: "Редактирование заказа", parentName: "orders" },
  "rejected-orders": { label: "Отклоненные заказы", parentName: "orders" },
  reasons: { label: "Причины", parentName: "products" },
  "additional-products": { label: "Дополнительные товары" },
  "florist-requests": { label: "Заявки флористов" },
  delivery: { label: "Доставка" },
};

export default {
  name: "AdminBreadcrumbs",
  computed: {
    breadcrumbs() {
      if (!this.$route.path.startsWith("/admin")) {
        return [];
      }

      const currentRouteName = this.$route.name;
      if (!currentRouteName) {
        return [];
      }

      const breadcrumbs = [
        {
          label: "Главная",
          to: { name: "orders" },
        },
      ];

      const routeMap = this.createRouteMap();
      const routeConfig = routeMap.get(currentRouteName);

      if (!routeConfig) {
        const fallbackLabel = this.toTitle(currentRouteName);
        breadcrumbs.push({ label: fallbackLabel });
        return breadcrumbs;
      }

      if (routeConfig.parentName) {
        const parentConfig = routeMap.get(routeConfig.parentName);
        if (parentConfig) {
          breadcrumbs.push({
            label: this.translate(parentConfig.label),
            to: parentConfig.to,
          });
        }
      }

      breadcrumbs.push({
        label: this.translate(routeConfig.label),
      });

      return breadcrumbs;
    },
  },
  methods: {
    createRouteMap() {
      const routeMap = new Map();

      navigationRoutes.routes.forEach((item) => {
        routeMap.set(item.name, {
          label: item.displayName,
          to: { name: item.name },
        });

        if (!item.children) {
          return;
        }

        item.children.forEach((child) => {
          const to =
            item.name === "content" && child.path
              ? { path: `/admin/content/${child.path}` }
              : { name: child.name };

          routeMap.set(child.name, {
            label: child.displayName,
            parentName: item.name,
            to,
          });
        });
      });

      Object.keys(extraBreadcrumbsByRouteName).forEach((routeName) => {
        const extraConfig = extraBreadcrumbsByRouteName[routeName];
        routeMap.set(routeName, {
          ...extraConfig,
          to: { name: routeName },
        });
      });

      return routeMap;
    },
    translate(label) {
      return this.$t(label);
    },
    toTitle(value) {
      return String(value)
        .split("-")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");
    },
  },
};
</script>

<style lang="scss">
.admin-breadcrumbs {
  margin-bottom: 1rem;

  &__list {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
    list-style: none;
    gap: 0.375rem;
    font-size: 0.875rem;
    color: #34495e;
  }

  &__item {
    display: inline-flex;
    align-items: center;
  }

  &__item + &__item::before {
    content: "/";
    margin-right: 0.375rem;
    color: #95a5a6;
  }

  &__link {
    color: #2c82e0;
    text-decoration: none;

    &:hover {
      color: #40b883;
      text-decoration: underline;
    }
  }

  &__current {
    color: #95a5a6;
  }
}
</style>
